import React, {Fragment} from 'react';
import Block from './Block';
import Title from './Title';

export function TitledBlock({size, type}) {
    return (
        <Fragment>
            <Title type={type} />
            <Block size={size} />
        </Fragment>
    );
}

export default TitledBlock;
